import { WretcherResponse } from 'wretch/dist/resolver';
import { EResponseStatus } from '../middlewares/middlewaresHelpers';
import { retryMiddleware } from '../middlewares/retryMiddleware';
import { getAffinyBaseEndPoint } from './baseEndpoint';

const shouldLoginRetryStop = (response: WretcherResponse) =>
  response.status === EResponseStatus.UNAUTHORIZED || response.ok;

export const AuthEndpoint = () =>
  getAffinyBaseEndPoint()
    .middlewares([retryMiddleware(shouldLoginRetryStop)])
    .url('/oauth');
